import React, { ErrorInfo } from 'react';

const FallbackComp = () => {
  return <div>Oops, Something went wrong!</div>;
};

class CatchErrorComp extends React.Component<{
  fallback?: React.ReactNode;
  component: React.ReactNode;
}> {
  public state = {
    error: null,
    errorInfo: null,
  };

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.log(error);
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    return this.state.error
      ? this.props.fallback || <FallbackComp />
      : this.props.component;
  }
}

export default CatchErrorComp;

export const CatchErrorHighOrder = (Component: React.ComponentType) => {
  return (props) => {
    return (
      <CatchErrorComp
        fallback={<FallbackComp />}
        component={<Component {...props}></Component>}
      ></CatchErrorComp>
    );
  };
};
